<template>
  <div class="profile-menu float-right ml-md-3" :class="!home ? 'd-none d-md-inline-block' : ''">
    <a class="profile-icon box-shadow" v-if="home">
      <span class="profile-img" :style="{ backgroundImage: 'url(' + avatarImage + ')' }"></span>
      <span class="initials">{{ this && this.user && this.user.personal ? this.user.personal.first_names.charAt(0) + this.user.personal.surname.charAt(0) : 'IN' }}</span>
    </a>
    <a class="profile-icon" v-else>
      <span class="profile-img" :style="{ backgroundImage: 'url(' + avatarImage + ')' }"></span>
      <span class="initials">{{ this && this.user && this.user.personal ? this.user.personal.first_names.charAt(0) + this.user.personal.surname.charAt(0) : 'IN' }}</span>
    </a>
    <b-dropdown no-caret right offset="-50" class="profile-menu" variant="link" toggle-class="text-decoration-none">
      <template #button-content>
        <feather class="color-white" type="more-vertical" v-if="home"></feather>
        <feather class="color-grey" type="more-vertical" v-else></feather>
      </template>
      <feather class="color-white arrow" type="corner-down-left" v-if="home"></feather>
      <feather class="color-grey arrow" type="corner-down-left" v-else></feather>
      <b-dropdown-item to="/profile"><feather type="user"></feather> My Profile</b-dropdown-item>
      <b-dropdown-item to="/organisation" v-if="hasCompany"><feather type="users"></feather> Organisation Profile</b-dropdown-item>
      <b-dropdown-item to="/profile/authorizations" v-if="auths"><feather type="key"></feather> Authorizations</b-dropdown-item>
      <b-dropdown-item to="/login" v-if="companies.length > 0"><feather type="refresh-cw"></feather> Switch Profile</b-dropdown-item>
      <b-dropdown-item href="#" @click.prevent="registerBusiness()"><feather type="plus-circle"></feather> Register a Business</b-dropdown-item>
      <b-dropdown-item href="#" v-if="false"><feather type="help-circle"></feather> Help and Support</b-dropdown-item>
      <b-dropdown-item href="#" @click.prevent="signOut()"><feather type="log-out"></feather> Logout</b-dropdown-item>
    </b-dropdown>
    <new-business></new-business>
    <new-business-details></new-business-details>
  </div>
</template>

<script>
import avatarImage from '@/assets/images/avatar-placeholder.png'
import { mapActions, mapState } from 'vuex'
import NewBusiness from './../modals/NewBusinessModal'
import NewBusinessDetails from './../modals/NewBusinessDetailsModal'

export default {
  components: {
    NewBusiness,
    NewBusinessDetails
  },
  props: {
    home: Boolean
  },
  data () {
    return {
      avatarImage: avatarImage
    }
  },
  computed: {
    ...mapState({
      company: state => state.company,
      userOauth: state => state.userOauth,
      userStore: state => state.auth.user
    }),
    auths () {
      if (this.userOauth.status === 'loaded') {
        return this.userOauth.auths && this.userOauth.auths.length > 0
      } else {
        return false
      }
    },
    companies () {
      if (this.company && this.company.companies) {
        return this.company.companies
      } else {
        return []
      }
    },
    user () {
      return this.userStore && this.userStore.user
    },
    hasCompany () {
      return this.user && this.user.company
    },
    companyActive () {
      return this.$route.path.indexOf('/organisation') >= 0
    },
    profileActive () {
      return this.$route.path.indexOf('/profile') >= 0 && this.$route.path !== '/profile/authorizations'
    },
    txActive () {
      return this.$route.path.indexOf('/transaction') >= 0 && !(this.$route.path.indexOf('/transaction/new') >= 0) && !(this.$route.path.indexOf('/transaction/pay') >= 0)
    },
    txNewActive () {
      return this.$route.path.indexOf('/transaction/new') >= 0
    },
    txPayActive () {
      return this.$route.path.indexOf('/transaction/pay') >= 0
    }
  },
  mounted () {
    if (this.company.status !== 'loaded') {
      this.getAll()
    }

    if (this.userOauth.status !== 'loaded') {
      this.getAuths()
    }
  },
  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('company', ['getAll']),
    ...mapActions('userOauth', {
      getAuths: 'get'
    }),
    ...mapActions('registration', {
      update: 'updateState'
    }),
    registerBusiness: function () {
      this.update({
        state: 'registration_type',
        value: 'Organisation'
      })
      this.update({
        state: 'walkthrough',
        value: {
          type: 'Individual',
          complete: true
        }
      })
      this.$bvModal.show('business-new')
    },
    signOut: function () {
      this.logout()
      this.$router.push('/login')
    }
  }
}
</script>
